module.exports = __webpack_public_path__ + "img/statistic_model.6165a5d4.png";